export const createLazyLoadState = () => {
  return createGlobalState(() => {
    const shouldLoad = ref(false);

    const load = () => {
      shouldLoad.value = true;
    };

    return {
      shouldLoad: readonly(shouldLoad),
      load,
    };
  });
};
